<template>
<div class="cohort-list">
<div class="container-fluid">
  <div class="table-responsive margin-Top-3Perc" >
    <table class="table table-striped ">
      <thead>
        <tr>
          <th class="text-align-center font-size-15px border-right">SR. No.</th>
          <th class="text-align-center font-size-15px border-right" v-if="checkForAvailability(getCohortList[0], 'group')">Group</th>
          <th class="text-align-center font-size-15px border-right" v-if="checkForAvailability(getCohortList[0], 'course')">Course</th>
          <th class="text-align-center font-size-15px border-right">Cohort</th>
          <th class="text-align-center font-size-15px border-right">Created TS</th>
          <th class="text-align-center font-size-15px">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(cohortObj, index) in getCohortList" :key="cohortObj.CohortId" v-bind:cohortObj = "cohortObj" >
          <td class="border-right text-align-center col-lg-1">{{(index + 1)}}</td>
          <td class="border-right text-align-center col-lg-3" v-if="checkForAvailability(cohortObj, 'group')">{{cohortObj.GroupName}}</td>
          <td class="border-right text-align-center col-lg-3" v-if="checkForAvailability(cohortObj, 'course')">{{getCourseTitleWithSubTitleValue(cohortObj)}}</td>
          <td class="border-right text-align-center col-lg-2">{{cohortObj.CohortName}}</td>
          <td class="border-right text-align-center col-lg-1">{{formatAndShowDate(cohortObj.CreatedTS)}}</td>
          <td class="text-align-center col-lg-2 cursor-pointer">
            <a class="text-decoration-underline" @click="performUserClickAction($event, 'view_group_challenge', cohortObj)"> View Goals</a> |
            <a class="text-decoration-underline" @click="performUserClickAction($event, 'view_group_action', cohortObj)"> View Actions</a>
          </td>         
        </tr>
      </tbody>
    </table>
    </div>
  </div>
  <!-- Show Spinner -->
  <div class="animationload" v-show="showSpinner">
    <div class="osahanloading"></div>
  </div>
  <view-associated-leaps-action-for-cohort v-if="openViewGroupActionOverlay" :selectedCohortObj="selectedCohortObj" @updateValues="closeVisibleOverlay"></view-associated-leaps-action-for-cohort>
  <view-associated-leaps-challenges-for-cohort v-if="openViewGroupChallengeOverlay" :selectedCohortObj="selectedCohortObj" @updateValues="closeVisibleOverlay"></view-associated-leaps-challenges-for-cohort>
  <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
  <loader></loader>
</div>
</template>
<script>
import AlertBox from '@/components/AlertOverlay'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import Loader from '@/components/dashboard/Loader'
import { has } from 'lodash'
import ViewAssociatedLeapsChallengesForCohort from './group/ViewAssociatedLeapsChallengesForCohort'
import ViewAssociatedLeapsActionsForCohort from './group/ViewAssociatedLeapsActionsForCohort'
export default {
  props: ['cohortList'],
  computed: {
    getCohortList: {
      get: function () {
        return this.cohortList
      }
    }
  },
  data: function () {
    return {
      isChecked: false,
      cohortDetails: [],
      viewEnrolledCourses: false,
      viewEnrolledCohorts: false,
      viewEnrolledParticipants: false,
      selectedGroupObj: null,
      showSpinner: false,
      showAlertDialog: false,
      errorMsg: '',
      openViewGroupChallengeOverlay: false,
      openViewGroupActionOverlay: false,
      selectedCohortObj: null
    }
  },
  name: 'cohort-list',
  methods: {
    checkForAvailability: function (cohortObj, operationName) {
      switch (operationName) {
        case 'group':
          return has(cohortObj, 'GroupName')
        case 'course':
          return has(cohortObj, 'CourseTitle')
        default:
          return false
      }
    },
    getCourseTitleWithSubTitleValue: function (cohortObj) {
      var valueToReturn = cohortObj.CourseTitle
      if (cohortObj.CourseSubTitle !== undefined && cohortObj.CourseSubTitle !== 'undefined' && cohortObj.CourseSubTitle !== null && cohortObj.CourseSubTitle !== 'null' && cohortObj.CourseSubTitle !== '') {
        valueToReturn += ' [' + cohortObj.CourseSubTitle + ']'
      }
      return valueToReturn
    },
    performUserClickAction: function (event, operationName, cohortObj) {
      this.selectedCohortObj = cohortObj
      switch (operationName) {
        case 'view_group_challenge':
          this.$store.state.isOverlayVisible = true
          this.openViewGroupChallengeOverlay = true
          break
        case 'view_group_action':
          this.$store.state.isOverlayVisible = true
          this.openViewGroupActionOverlay = true
          break
      }
    },
    closeVisibleOverlay: function () {
      this.openViewGroupChallengeOverlay = false
      this.openViewGroupActionOverlay = false
      this.$store.state.isOverlayVisible = false
    },
    formatAndShowDate: function (date) {
      var dateToPass = date
      if (dateToPass.indexOf('Z') === -1) {
        dateToPass += 'Z'
      }
      return dmAdminUtils.covertUtcToEst(dateToPass)
    },
    viewCourseList: function (event, flagToUpdate, selectedCohortObj) {
      // this.viewEnrolledCourses = flagToUpdate
      this.selectedCohortObj = selectedCohortObj
      if (selectedCohortObj.CourseCount === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'No course found in "' + selectedCohortObj.CourseName + '".'
        return
      }
      this.getEnrolledCourses()
    },
    viewCohortList: function (event, flagToUpdate, selectedCohortObj) {
      // this.viewEnrolledCourses = flagToUpdate
      this.selectedCohortObj = selectedCohortObj
      if (selectedCohortObj.CohortCount === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'No cohort found in "' + selectedCohortObj.GroupName + '".'
        return
      }
      this.getEnrolledCohorts()
    },
    viewParticipantList: function (event, flagToUpdate, selectedCohortObj) {
      // this.viewEnrolledCourses = flagToUpdate
      this.selectedCohortObj = selectedCohortObj
      if (selectedCohortObj.ParticipantCount === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'No participant found in "' + selectedCohortObj.GroupName + '".'
        return
      }
      this.getEnrolledParticipants()
    },
    updateViewEnrolledCoursesFlag (value) {
      // AK: used to close the overlay (view enrolled courses page) by pressing Close
      this.viewEnrolledCourses = value
      // AK: Enable Background Scrolling
      this.$store.state.isOverlayVisible = value
    },
    updateViewEnrolledCohortsFlag (value) {
      // AK: used to close the overlay (view enrolled cohort page) by pressing Close
      this.viewEnrolledCohorts = value
      // AK: Enable Background Scrolling
      this.$store.state.isOverlayVisible = value
    },
    updateViewEnrolledParticipantsFlag (value) {
      // AK: used to close the overlay (view enrolled Participant page) by pressing Close
      this.viewEnrolledParticipants = value
      // AK: Enable Background Scrolling
      this.$store.state.isOverlayVisible = value
    },
    getEnrolledCourses: function () {
      var storeObj = this.$store
      var _this = this
      // alert(this.LessonObj.ModuleId)
      if (
        this.selectedCohortObj.CohortId !== undefined &&
        this.selectedCohortObj.CohortId !== null
      ) {
        // _this.showSpinner = true
        _this.$store.state.isLoading = true
        // groupService
          .getCourseList(
            storeObj.state.access_token,
            this.selectedCohortObj.CohortId
          )
          .then(
            responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                // AK: Assign it to enrolledCourseList
                this.enrolledCourseList = responseObj.data
                // AK: Hide Spinner after recieving Enrolled course list and show overlay
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
                _this.viewEnrolledCourses = true
                // AK: Disable Background Scrolling
                this.$store.state.isOverlayVisible = true

                // console.log(JSON.stringify(this.enrolledCourseList))
              } else {
                _this.showAlertDialog = true
                _this.errorMsg =
                  'Oops! Something went wrong. Please try again.'
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            },
            errorObj => {
              // AK: Hide Spinner
              // this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = errorObj.response.data.statusText
            }
          )
      } else {
        console.log(
          'CohortId is NULL hence declined LOADING ENROLLED COURSE LIST OPERATION'
        )
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    getEnrolledCohorts: function () {
      var storeObj = this.$store
      var _this = this
      // alert(this.LessonObj.ModuleId)
      if (
        this.selectedCohortObj.CohortId !== undefined ||
        this.selectedCohortObj.CohortId !== null
      ) {
        // _this.showSpinner = true
        _this.$store.state.isLoading = true
        // cohortService
          .getCohortList(
            storeObj.state.access_token,
            this.selectedCohortObj.CohortId
          )
          .then(
            responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                // AK: Assign it to enrolledCohortList
                this.enrolledCohortList = responseObj.data
                // AK: Hide Spinner after recieving Enrolled Cohort list and show overlay
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
                _this.viewEnrolledCohorts = true
                // AK: Disable Background Scrolling
                this.$store.state.isOverlayVisible = true
                // console.log(JSON.stringify(this.enrolledCohortList))
              } else {
                _this.showAlertDialog = true
                _this.errorMsg =
                  'Oops! Something went wrong. Please try again.'
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            },
            errorObj => {
              // AK: Hide Spinner
              // this.showSpinner = false
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = errorObj.response.data.statusText
            }
          )
      } else {
        console.log(
          'CohortId is NULL hence declined LOADING ENROLLED COHORT LIST OPERATION'
        )
      }
    },
    getEnrolledParticipants: function () {
      var storeObj = this.$store
      var _this = this
      // alert(this.LessonObj.ModuleId)
      if (
        this.selectedCohortObj.CohortId !== undefined ||
        this.selectedCohortObj.CohortId !== null
      ) {
        // _this.showSpinner = true
        _this.$store.state.isLoading = true
        // participantService
          .getParticipantList(
            storeObj.state.access_token,
            this.selectedCohortObj.CohortId
          )
          .then(
            responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                // AK: Assign it to enrolledCourseList
                this.enrolledParticipantList = responseObj.data
                // AK: Hide Spinner after recieving Enrolled course list and show overlay
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
                _this.viewEnrolledParticipants = true
                // AK: Disable Background Scrolling
                this.$store.state.isOverlayVisible = true
                // console.log(JSON.stringify(this.enrolledParticipantList))
              } else {
                _this.showAlertDialog = true
                _this.errorMsg =
                  'Oops! Something went wrong. Please try again.'
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            },
            errorObj => {
              // AK: Hide Spinner
              // this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = errorObj.response.data.statusText
            }
          )
      } else {
        console.log(
          'CohortId is NULL hence declined LOADING ENROLLED COURSE LIST OPERATION'
        )
      }
    }
    /* selectAll () {
      this.isChecked = true
      this.updateGroupDetails()
    },
    deSeclectAll () {
      this.isChecked = false
      this.updateGroupDetails()
    }
    ,
    updateGroupDetails () {
      console.log('UPDATE GROUP DETAILS')
      for (var ii = 0; ii < this.groupDetails.length; ii++) {
        console.log(this.groupDetails[ii])
        this.groupDetails[ii].isSelected = this.isChecked
      }
    } */
  },
  components: {
    // 'view-enrolled-courses': ViewEnrolledCourseList,
    'view-associated-leaps-challenges-for-cohort': ViewAssociatedLeapsChallengesForCohort,
    'view-associated-leaps-action-for-cohort': ViewAssociatedLeapsActionsForCohort,
    'alert-box': AlertBox,
    'loader': Loader
    // 'view-enrolled-cohorts': ViewEnrolledCohortList,
    // 'view-enrolled-participants': ViewEnrolledParticipantList
  }
}
</script>
<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.text-align-left {
  text-align: left;
}
.margin-Top-1Perc {
  margin-top: 1%;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.margin-Top-3Perc {
  margin-top: 3%;
}
.margin-Top-6Perc {
  margin-top: 6%;
}
.margin-left-1Perc {
  margin-left: 1%;
}
.margin-left-2Perc {
  margin-left: 2%;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.overflow-x-hidden {
  overflow-x: hidden !important;
}
.cohort-list {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding-left: inherit;
  padding-right: inherit;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
.table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}
.border-right {
  border-right: 1px solid #aaa !important;
}
.text-align-center {
  text-align: center !important;
}
.font-size-15px {
  font-size: 15px !important;
}
a:link {
  color: #2c3e50;
}
a:visited {
  color: #2c3e50;
}
a:hover {
  color: #2c3e50;
}
a:active {
  color: #2c3e50;
}
.btn-text-color {
  color: #2c3e50;
}
.cursor-pointer {
  cursor: pointer;
}
.text-decoration-underline {
  text-decoration: underline;
}
.table>thead>tr>th {
    vertical-align: bottom;
    border-bottom: 0px solid #aaaaaa;
}
.text-align-center{
  text-align: center !important;
}
a{
  color: #2c3e50 !important;
}
a:link {
  color: #2c3e50;
}
a:visited {
  color: #2c3e50;
}
a:hover {
  color: #2c3e50;
}
a:active {
  color: #2c3e50;
}
</style>


// WEBPACK FOOTER //
// src/components/CohortList.vue